import { Button } from 'react-bootstrap';

export const SubmitButton = ({
    isLoading,
    children,
}) => {

    return (
        <Button
            style={{ minWidth: '97px', height: '41px' }}
            variant="btn btn-base text-white bg-blue-dark"
            type="submit"
        >
            {
                isLoading
                ?
                    <div className="spinner-border spinner-border-sm" role="status">
                        <span className="sr-only"></span>
                    </div>
                :
                    children
            }
        </Button>
    );
}
